module.exports = __webpack_public_path__ + "static/media/information.caf7cbe8.svg";